import { lazy } from "react";
import Loadable from "../../../../../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../../../../../router/AuthorizedRoute";
import { MODULE_IDS } from "../../../../../../constants/enums";

const SOVTab = Loadable(
  lazy(() =>
    import("./SOVTab").then(({ SOVTab }) => ({
      default: SOVTab,
    }))
  )
);

const SOVCreatePage = Loadable(
  lazy(() =>
    import("./SOVCreatePage").then(({ SOVCreatePage }) => ({
      default: SOVCreatePage,
    }))
  )
);

export const SOVTabRoutes = [
  {
    path: `/business-policy/:customerId/sov-tab/:customerPolicyId`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.BUSINESS_POLICY]}>
        <SOVTab />
      </AuthorizedRoute>
    ),
  },
  {
    path: `/business-policy/:customerId/sov-tab/:customerPolicyId/create`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.BUSINESS_POLICY]}>
        <SOVCreatePage />
      </AuthorizedRoute>
    ),
  },
];
